import CustomLayout from "./CustomLayout";

export default CustomLayout;